<script setup>
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { message, Modal } from 'ant-design-vue';
import { createVNode, ref } from 'vue';
import { useAdminStore } from '../../stores/admin';
import { getData } from '../../utils/googleSheet';
const loading = ref(false)
const AdminStore = useAdminStore()

function translateSheetToObj(sheetArray, columns) {
  console.log(columns)
  const obj = sheetArray.reduce((arr, row, index) => {
    console.log(index)
    arr.push(row.reduce((a, c, i) => ({ ...a, [columns[i]]: c}), {}))
    return arr
  }, [])
  previewSheetColumn.value = columns.map(c => ({ dataIndex: c, key: c, title: c }))
  previewSheet.value = obj
}

const regex = /spreadsheets\/d\/([\w\W]+)\/edit#gid=([\d]+)/i
const sheetUrl = ref()
const previewSheet = ref()
const previewSheetColumn = ref()
const connectSheet = async () => {
  loading.value = true
  let [fullPatern, documentId, sheetId] = sheetUrl.value.match(regex)
  console.log(fullPatern, documentId, sheetId)
  if (documentId && sheetId) {
    console.log(fullPatern, documentId, sheetId)
    const { columns, rows } = await getData(documentId, sheetId)
    try {
      console.log(rows)
      translateSheetToObj(rows, columns)
      message.success('已成功連結試算表')
    } catch (error) {
      console.log(error)
    }
  } else {
    message.warning('找不到對應的試算表，請確認網址是否正確')
  }
  
  loading.value = false
}

const saveIntoFirestore = async collectionName => {
  const result = await AdminStore.batchWriteToCollection(collectionName, previewSheet.value)
  if (result.state === 'SUCCESS') message.success('已存入資料庫')
  else message.error(result.message)
  console.log(result)
}

const modalHasShow = ref(false)
const targetCollection = ref('User')
const showModal = () => {
  if (previewSheet.value) modalHasShow.value = true
  else message.warning('請先連結要存取的 Google 試算表')
}
const showCofirm = () => {
  Modal.confirm({
    title: () => '確定要將連結的 Google Sheet 存入資料庫？',
    icon: () => createVNode(ExclamationCircleOutlined),
    content: () => '確認存入後資料庫將會覆寫編號相同的資料，請確認欲存入資料是否正確',
    cancelText: () => '取消',
    okText: () => '確認存入',
    onOk() {
      return new Promise((resolve) => {
        saveIntoFirestore(targetCollection.value).then(() => {
          resolve()
          modalHasShow.value = false
        })
      })
    },
    onCancel() {},
  });
}
</script>

<template>
  <div class="view-admin-insert">
    <a-page-header
      style="border: 1px solid rgb(235, 237, 240)"
      title="匯入 Google 試算表資料"
      sub-title="匯入試算表之前，請先確認是否有將試算表開啟共用並分享予「twentythreesearch@twenty-three-search.iam.gserviceaccount.com」"
    />

    <a-card>
      <header>
        <b>輸入欲連結的 Google 試算表網址：</b>
        <a-input v-model:value="sheetUrl"></a-input>
        <a-button type="primary" :loading="loading" @click="connectSheet">連結</a-button>
      </header>

      <section>
        <a-table :columns="previewSheetColumn" :data-source="previewSheet" :scroll="{ x: 500 }" bordered>
        <template #title>
          連結資料預覽
        </template></a-table>
      </section>
      <a-button type="primary" @click="showModal">選擇存取資料庫</a-button>
    </a-card>

    <a-modal v-model:visible="modalHasShow" title="選擇要存入的資料庫" :footer="null">
      <a-radio-group v-model:value="targetCollection" button-style="solid">
        <a-radio-button value="User">使用者資料庫</a-radio-button>
        <a-radio-button value="Clothe">衣物案件資料庫</a-radio-button>
      </a-radio-group>

      <a-button type="primary" @click="showCofirm">存入資料庫</a-button>
    </a-modal>
  </div>
</template>
